module.exports = __webpack_public_path__ + "static/media/compound5.6f71775a.jpg";